// extracted by mini-css-extract-plugin
export default {"BranchExceptions":"branchView_BranchExceptions__CSf-l"};